const topics = [
  {
    title: '2025年度高分电影TOP50',
    desc: '综合豆瓣、IMDb等平台评分，整理年度必看电影清单，收藏起来慢慢看。',
    count: '38部更新中',
    icon: 'ri-trophy-line',
  },
  {
    title: '国产悬疑剧高能反转合集',
    desc: '《隐秘的角落》《沉默的真相》同款口碑好剧，悬疑爱好者不容错过。',
    count: '24部精选',
    icon: 'ri-search-eye-line',
  },
  {
    title: '周末宅家必刷喜剧电影',
    desc: '轻松治愈无负担，从开心麻花到好莱坞经典喜剧，笑到停不下来。',
    count: '56部收录',
    icon: 'ri-emotion-happy-line',
  },
  {
    title: '韩剧高分爱情片单',
    desc: '从《鬼怪》到《眼泪女王》，那些让你心动的高分韩剧都在这里。',
    count: '42部精选',
    icon: 'ri-heart-line',
  },
  {
    title: '好莱坞科幻大片全收录',
    desc: '从经典到最新，星际穿越、盗梦空间级别的科幻大制作一次看过瘾。',
    count: '67部收录',
    icon: 'ri-rocket-line',
  },
  {
    title: '豆瓣9分以上动画电影',
    desc: '千与千寻、寻梦环游记等殿堂级动画，适合全家一起看的温暖佳作。',
    count: '29部精选',
    icon: 'ri-movie-line',
  },
  {
    title: '深夜美食纪录片合集',
    desc: '《舌尖》《风味人间》同款美食纪录片，饭点慎点，容易馋哭。',
    count: '18部更新中',
    icon: 'ri-bowl-line',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="relative py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100/70 text-accent-700 text-xs font-semibold mb-4">
            精选合集
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            专题合集
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            按类型、评分、题材精心整理，帮你快速找到想看的影视内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {topics.slice(0, 4).map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 rounded-xl p-6 md:p-7 hover:bg-primary-50/40 transition-colors duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100/60 text-accent-600 mb-4 group-hover:bg-accent-200/60 transition-colors">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3">{item.desc}</p>
              <span className="inline-block px-3 py-1 rounded-full bg-background-200/70 text-foreground-600 text-xs font-medium whitespace-nowrap">
                {item.count}
              </span>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 md:gap-6 mt-5 md:mt-6">
          {topics.slice(4).map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 rounded-xl p-6 md:p-7 hover:bg-accent-50/40 transition-colors duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100/60 text-primary-600 mb-4 group-hover:bg-primary-200/60 transition-colors">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3">{item.desc}</p>
              <span className="inline-block px-3 py-1 rounded-full bg-background-200/70 text-foreground-600 text-xs font-medium whitespace-nowrap">
                {item.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}